// Safe wrappers for browser storage. Only NON-SENSITIVE preferences are stored here
// (theme, last selected organization id, sidebar state, "remember me" flag).
// Authentication tokens are managed exclusively by the Supabase client adapter in api/client.js.

const PREFIX = 'ngw.';

function store(kind) {
  try { return kind === 'session' ? window.sessionStorage : window.localStorage; } catch { return null; }
}

export function getPref(key, fallback = null) {
  try { return store('local')?.getItem(PREFIX + key) ?? fallback; } catch { return fallback; }
}
export function setPref(key, value) {
  try { store('local')?.setItem(PREFIX + key, String(value)); } catch { /* storage unavailable */ }
}
export function removePref(key) {
  try { store('local')?.removeItem(PREFIX + key); } catch { /* storage unavailable */ }
}
